export default __webpack_public_path__ + "static/media/1284.dc095d22.png";